if ("NodeList" in window && !NodeList.prototype.forEach) {
	console.info("Polyfill for IE11");
	NodeList.prototype.forEach = function (callback, thisArg) {
		thisArg = thisArg || window;
		for (let i = 0; i < this.length; i++) {
			callback.call(thisArg, this[i], i, this);
		}
	};
}

(function () {
	// Remove empty <p> tags created by tinymce
	const paragraph = document.querySelectorAll("p") || [];
	paragraph.forEach(
		(e) => e.innerHTML.trim() === "" && e.parentNode.removeChild(e)
	);

	// Autofill input with current date
	let today = new Date();
	let month = formatDate(today.getMonth()+1);
	let day = formatDate(today.getDate());
	let year = today.getFullYear();

	function formatDate(value) {
		if (value < 10) {
			return `0${value}`;
		} else {
			return value;
		}
	}
	
	const dateSubmission = document.querySelector('.current-date-js input');

	if (dateSubmission) {
		setTimeout(() => {
			dateSubmission.value = month+'/'+day+'/'+year;
		}, 1000);
	}
})();
